// web-staking-estimator-frontend/src/hooks/map/useMapReset.js
import { useEffect } from "react";
import Extent from "@arcgis/core/geometry/Extent";
import * as webMercatorUtils from "@arcgis/core/geometry/support/webMercatorUtils";

/**
 * Hook to handle map reset functionality
 * Clears graphics and returns to default extent
 */
export function useMapReset({
  resetSignal,
  viewRef,
  clickLayerRef,
  resultsLayerRef,
  lastPointRef,
  onNearestSummary,
}) {
  useEffect(() => {
    if (!resetSignal) return;
    
    const view = viewRef.current;
    
    // Clear graphics layers
    try {
      clickLayerRef.current?.removeAll();
    } catch {}
    try {
      resultsLayerRef.current?.removeAll();
    } catch {}

    // Clear remembered point
    if (lastPointRef) {
      lastPointRef.current = null;
    }

    // Reset map extent
    if (view) {
      try {
        const geoExtent = new Extent({
          xmin: -119.64094590215939,
          ymin: 43.45505949954564,
          xmax: -117.35241574718627,
          ymax: 45.76247392572059,
          spatialReference: { wkid: 4326 },
        });
        const wmExtent = webMercatorUtils.geographicToWebMercator(geoExtent);
        view.goTo(wmExtent);
      } catch (e) {
        console.warn("Reset extent failed:", e);
      }
    }

    // Clear nearest summary
    try {
      onNearestSummary?.({ xfmrOHUG: null, infraPhase: null, noneFound: false });
    } catch {}
  }, [resetSignal, viewRef, clickLayerRef, resultsLayerRef, lastPointRef, onNearestSummary]);
}
